// @flow

import { connect } from 'react-redux';

import { selectIsSamlUser } from '@gandi/authentication';
import {
  type DecoratedProduct,
  selectCartUUID as selectCartId,
  selectOneProduct,
  selectCartProductOwner,
  selectCartReselleeID as selectCartCustomer,
} from '@gandi/cart';
import {
  selectOneOrganization,
  type Organization as ROrganization,
} from '@gandi/redux-organization';
import type { Organization as SOrganization } from '@gandi/redux-sharing';

import { selectShopCurrent } from '../../../../../../modules/organization/selectors';
import type { FullState } from '../../../../../../types';

export type OwnProps = {
  productId: string | number,
};

export type OwnerProps = {
  product: DecoratedProduct,
  currentOrganization: SOrganization | void,
  productOwner: string,
  productOwnerOrg: ?ROrganization,
  cartCustomer: string,
  cartId: string,
  isSamlUser: boolean,
};

const selectProductOwnerOrg = (state: FullState): ?ROrganization => {
  const productOwner = selectCartProductOwner(state);
  if (!productOwner) {
    return undefined;
  }

  const productOrg = selectOneOrganization(state, productOwner);
  if (!productOrg) {
    return null;
  }

  return productOrg;
};

const mapStateToProps = (state: FullState, ownProps: OwnProps): OwnerProps => ({
  // $FlowFixMe product may be undefined
  product: selectOneProduct(state, { productId: ownProps.productId }),
  currentOrganization: selectShopCurrent(state, false),
  productOwner: selectCartProductOwner(state),
  productOwnerOrg: selectProductOwnerOrg(state),
  cartCustomer: selectCartCustomer(state),
  cartId: selectCartId(state),
  isSamlUser: selectIsSamlUser(state),
});

// $FlowFixMe[cannot-resolve-name]
// $FlowFixMe[incompatible-call]
export default (connect(mapStateToProps): Connector<
  mixed,
  OwnProps,
  // $FlowFixMe[cannot-resolve-name]
  MergeOPSP<OwnProps, OwnerProps, mixed>,
>);
